import React, {useState} from 'react'
import { HowToPlayModalModal } from '../modals/how-to-play/HowToPlayModal';
import { LanguagesModal } from '../modals/languages/LanguagesModal';


import './Header.css'

export const Header = () => {

  const [isLanguagesModalOpen, setIsLanguagesModalOpen] = useState(false);
  const handleCloseLanguagesModal = () => {
    setIsLanguagesModalOpen(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'scroll';
  };

  const handleOpenLanguagesModal = () => {
    setIsLanguagesModalOpen(true);
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'scroll';
  };

  const [isHowToPlayModalOpen, setIsHowToPlayModalOpen] = useState(false);
  const handleCloseHowToPlayModalModal = () => {
    setIsHowToPlayModalOpen(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'scroll';
  };

  const handleOpenHowToPlayModalModal = () => {
    setIsHowToPlayModalOpen(true);
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'scroll';
  };

  return (
    <div className='Header'>
        <div className='header-btns'>
          
          <div className='how-play-container' onClick={handleOpenHowToPlayModalModal}>
            <img 
              className='how-to-play'         
              src="informacion11.png" alt="HowToPlay" 
            />
          </div>
          
          <HowToPlayModalModal isOpen={isHowToPlayModalOpen} onClose={handleCloseHowToPlayModalModal}/>

          <a href='https://lolboard.netlify.app/' title='LoLBoard'>
              <img className='logo' src='logo-game.png' alt='Logo'/>
          </a>

          <div className='how-play-container'>
            <img className='idioma' 
              onClick={() => handleOpenLanguagesModal()}
              src="idioma.png" 
              alt="Languages" />
          </div>

          <LanguagesModal isOpen={isLanguagesModalOpen} onClose={handleCloseLanguagesModal}/>
        
        </div>
    </div>
  )
}